import * as React from 'react';
import {cva, type VariantProps} from 'class-variance-authority';

import {cn} from '@/lib/utils';

const headingVariants = cva('font-recoleta-alt text-font-color-1', {
  variants: {
    variant: {
      h1: '~text-[38px]/[60px] ~leading-[44px]/[69px] font-medium -tracking-[1.5px] md:-tracking-[2px]',
      h2: '~text-[32px]/[48px] ~leading-[38px]/[55px] font-medium -tracking-[0.5px] md:-tracking-[2px]',
      h3: '~text-[28px]/[39px] ~leading-[34px]/[47px] font-normal -tracking-[0.5px] md:-tracking-[2px]',
      h4: '~text-[25px]/[31px] ~leading-[30px]/[46px] font-medium -tracking-[1px]',
      h5: 'text-[1rem] leading-[1.5rem] font-bold font-inter',
      h6: 'text-[0.75rem] leading-[1.5rem] font-[550] font-inter -tracking-[0.5px]',
    },
  },
});

export interface HeadingProps
  extends React.BaseHTMLAttributes<HTMLHeadingElement>,
    VariantProps<typeof headingVariants> {}

const Heading = React.forwardRef<HTMLHeadingElement, HeadingProps>(
  ({className, variant, ...props}, ref) => {
    switch (variant) {
      case 'h1':
        return (
          <h1
            className={cn(headingVariants({variant, className}))}
            ref={ref}
            {...props}
          />
        );
      case 'h2':
        return (
          <h2
            className={cn(headingVariants({variant, className}))}
            ref={ref}
            {...props}
          />
        );
      case 'h3':
        return (
          <h3
            className={cn(headingVariants({variant, className}))}
            ref={ref}
            {...props}
          />
        );
      case 'h4':
        return (
          <h4
            className={cn(headingVariants({variant, className}))}
            ref={ref}
            {...props}
          />
        );
      case 'h5':
        return (
          <h5
            className={cn(headingVariants({variant, className}))}
            ref={ref}
            {...props}
          />
        );
      case 'h6':
        return (
          <h6
            className={cn(headingVariants({variant, className}))}
            ref={ref}
            {...props}
          />
        );
    }
  },
);
Heading.displayName = 'Heading';

export {Heading, headingVariants};
